/* eslint-disable import/no-unused-modules */
import React from 'react';
import PhotoDetailHeader from '../../components/General/PhotoDetailHeader';
import PostGrid from '../../components/Grid/PostGrid';
import Header from '../../components/Header/Header';
import capitalize from '../../helpers/capitalize';
import { GET_LOCATION_DETAILS } from '../../helpers/graphql/locations';
import graphQLClient from '../../helpers/graphQLClient';
import withApollo from '../../lib/withApollo';

const TagPage = ({ locationDetails, tag }) => {
  return (
    <>
      <Header active="tag" isScrollingNav />
      <PhotoDetailHeader
        locationDetails={locationDetails}
        tag={tag}
        query={{ tag }}
        title={capitalize(tag)}
        feedUrl={`topics/${tag}`}
      />
      <div className="pb-2">
        <div className="container containerInvisibleOnMobile">
          <PostGrid
            active="topic"
            query={{
              tag,
              orderby: 'score',
              limit: 9,
              language: 'en',
            }}
            grid={{ lg: 4, md: 4, sm: 6, xs: 12 }}
            cardHeight={200}
            poststyle="grid"
          />
        </div>
      </div>
    </>
  );
};

export async function getStaticProps({ params }) {
  const { tag } = params;

  try {
    const fetchDestination = await graphQLClient(GET_LOCATION_DETAILS, { tag });

    if (!fetchDestination || !fetchDestination.locationDetails)
      return { notFound: true, revalidate: 10 };

    return {
      props: { locationDetails: fetchDestination.locationDetails, tag },
      revalidate: 10,
    };
  } catch {
    return { notFound: true, revalidate: 10 };
  }
}

export async function getStaticPaths() {
  return { paths: [], fallback: 'blocking' };
}

export default withApollo(TagPage);
